import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { MULTI_SELECT_PROPS, PropsTable, RADIO_SELECT_PROPS, SELECT_DEFAULT_PROPS, SELECT_PROPS } from "./Props/Props";


const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
  search: { label: "Search", color: "#FDF2F8", textColor: "#9D174D" },
  default: { label: "Default", color: "#FFF7ED", textColor: "#C2410C" },
};


const SelectList = () => {
  const [select, setSelect] = useState("");
  const [selected, setSelected] = useState({
    label: "Option 3",
    value: "option3",
  });
  const [selectDisabled, setSelectDisabled] = useState("");
  const [selectedDisabled, setSelectedDisabled] = useState({
    label: "Option 3",
    value: "option3",
  });
  const [selectMultiple, setSelectMultiple] = useState([]);
  const [selectMultipleSelected, setSelectMultipleSelected] = useState([
    {
      label: "Option 3",
      value: "option3",
    },
    {
      label: "Option 4",
      value: "option4",
    },
  ]);
  const [selectMultipleDisabled, setSelectMultipleDisabled] = useState([]);
  const [selectMultipleSelectedDisabled, setSelectMultipleSelectedDisabled] =
    useState([
      {
        label: "Option 3",
        value: "option3",
      },
      {
        label: "Option 4",
        value: "option4",
      },
    ]);
  const [selectWithSearch, setSelectWithSearch] = useState("");
  const [selectedWithSearch, setSelectedWithSearch] = useState({
    label: "Option 3",
    value: "option3",
  });
  const [selectWithSearchDisabled, setSelectWithSearchDisabled] = useState("");
  const [selectedWithSearchDisabled, setSelectedWithSearchDisabled] = useState({
    label: "Option 3",
    value: "option3",
  });
  const [selectWithSearchAndAddButton, setSelectWithSearchAndAddButton] =
    useState("");
  const [selectedWithSearchAndAddButton, setSelectedWithSearchAndAddButton] =
    useState({
      label: "Option 3",
      value: "option3",
    });
  const [
    selectWithSearchAndAddButtonDisabled,
    setSelectWithSearchAndAddButtonDisabled,
  ] = useState("");
  const [
    selectedWithSearchAndAddButtonDisabled,
    setSelectedWithSearchAndAddButtonDisabled,
  ] = useState({
    label: "Option 3",
    value: "option3",
  });
  const [radioSelect, setRadioSelect] = useState();
  const [radioSelected, setRadioSelected] = useState("option1");
  const [radioSelectDisabled, setRadioSelectDisabled] = useState();
  const [radioSelectedDisabled, setRadioSelectedDisabled] = useState("option1");

  const [checkMultiSelect, setCheckMultiSelect] = useState([]);
  const [checkMultiSelected, setCheckMultiSelected] = useState([
    "option1",
    "option2",
  ]);
  const [checkMultiSelectDisabled, setCheckMultiSelectDisabled] = useState([]);
  const [checkMultiSelectedDisabled, setCheckMultiSelectedDisabled] = useState([
    "option1",
    "option2",
  ]);
  const [selectedCompany, setSelectedCompany] = useState("deloitte");
  const [defaultCompany, setDefaultCompany] = useState("deloitte");
  const [selectedCompanyWithSearch, setSelectedCompanyWithSearch] =
    useState("oracle");
  const [defaultCompanyWithSearch, setDefaultCompanyWithSearch] =
    useState("oracle");
  const [selectedCompanyDisabled, setSelectedCompanyDisabled] = useState("ibm");
  const [defaultCompanyDisabled, setDefaultCompanyDisabled] = useState("ibm");
  const [selectedCompanyNoLogo, setSelectedCompanyNoLogo] =
    useState("tech-mahindra");
  const [defaultCompanyNoLogo, setDefaultCompanyNoLogo] =
    useState("tech-mahindra");
  const sampleCompanies = [
    {
      value: "itc",
      label: "ITC",
      logo: "https://logo.clearbit.com/itcportal.com",
    },
    {
      value: "oracle",
      label: "Oracle",
      logo: "https://logo.clearbit.com/oracle.com",
    },
    {
      value: "deloitte",
      label: "Deloitte",
      logo: "https://logo.clearbit.com/deloitte.com",
    },
    {
      value: "tech-mahindra",
      label: "Tech Mahindra",
      logo: "https://logo.clearbit.com/techmahindra.com",
    },
    {
      value: "dell",
      label: "Dell",
      logo: "https://logo.clearbit.com/dell.com",
    },
    {
      value: "accenture",
      label: "Accenture",
      logo: "https://logo.clearbit.com/accenture.com",
    },
    {
      value: "ibm",
      label: "IBM",
      logo: "https://logo.clearbit.com/ibm.com",
    },
    {
      value: "cgi",
      label: "CGI",
      logo: "https://logo.clearbit.com/cgi.com",
    },
  ];

  const handleCompanyChange = (value) => {
    console.log("Selected company:", value);
    setSelectedCompany(value);
  };

  const handleSetDefault = (value) => {
    console.log("Setting default company:", value);
    setDefaultCompany(value);
  };

  const handleCompanyWithSearchChange = (value) => {
    console.log("Selected company (with search):", value);
    setSelectedCompanyWithSearch(value);
  };

  const handleSetDefaultWithSearch = (value) => {
    console.log("Setting default company (with search):", value);
    setDefaultCompanyWithSearch(value);
  };

  const handleCompanyNoLogoChange = (value) => {
    console.log("Selected company (no logo):", value);
    setSelectedCompanyNoLogo(value);
  };

  const handleSetDefaultNoLogo = (value) => {
    console.log("Setting default company (no logo):", value);
    setDefaultCompanyNoLogo(value);
  };

  const handleSelectChange = (value) => {
    setSelect(value);
  };

  const handleSelectedChange = (value) => {
    setSelected(value);
  };

  const handleSelectMultipleChange = (value) => {
    setSelectMultiple(value);
  };

  const handleSelectMultipleSelectedChange = (value) => {
    setSelectMultipleSelected(value);
  };

  const handleSelectWithSearchChange = (value) => {
    setSelectWithSearch(value);
  };

  const handleSelectedWithSearchChange = (value) => {
    setSelectedWithSearch(value);
  };

  const handleSelectWithSearchAndAddButtonChange = (value) => {
    setSelectWithSearchAndAddButton(value);
  };

  const handleSelectedWithSearchAndAddButtonChange = (value) => {
    setSelectedWithSearchAndAddButton(value);
  };

  const handleViewClick = (value) => {
    console.log(`View Button ${value} Clicked`);
  };

  const options = [
    { label: "Option 1", value: "1" },
    { label: "Option 2", value: "2" },
    { label: "Option 3", value: "3" },
    // { label: "Option 4", value: "option4" },
  ];

  const options2 = [
    {
      label: "Option 1",
      value: "1",
      badges: {
        email: { value: 10000, color: "success", colorDepth: "500" },
        phone: { value: 5, color: "warning", colorDepth: "100" },
        tasks: { value: 3, color: "danger", colorDepth: "500" },
      },
    },
    {
      label: "Option 2",
      value: "2",
      badges: {
        email: { value: 25, color: "info", colorDepth: "600" },
        phone: { value: 12, color: "primary", colorDepth: "500" },
      },
    },
  ];

  return (
    <>
      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select"
            showBadges={true}
            badgeSize={"xs-sm"}
            placeholder="Select Option"
            options={options2}
            value={select}
            onChange={handleSelectChange}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select"
            placeholder="Select Option"
            options={options}
            value={selected}
            onChange={handleSelectedChange}
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select"
            placeholder="Select Option"
            options={options}
            value={selectDisabled}
            onChange={handleSelectChange}
            disabled
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select"
            placeholder="Select Option"
            options={options}
            value={selectedDisabled}
            onChange={handleSelectedChange}
            disabled
            shadow={true}
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            type="select"
            multiple
            style="chip"
            label="Input"
            title="Select Multiple"
            placeholder="Select Multiple Option"
            options={options}
            value={selectMultiple}
            onChange={handleSelectMultipleChange}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            multiple
            style="chip"
            label="Input"
            title="Select Multiple Selected"
            placeholder="Select Multiple Option"
            options={options}
            value={selectMultipleSelected}
            onChange={handleSelectMultipleSelectedChange}
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            multiple
            style="chip"
            label="Input"
            title="Select Multiple"
            placeholder="Select Multiple Option"
            options={options}
            value={selectMultipleDisabled}
            onChange={handleSelectMultipleChange}
            disabled
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            multiple
            style="chip"
            label="Input"
            title="Select Multiple Selected"
            placeholder="Select Multiple Option"
            options={options}
            value={selectMultipleSelectedDisabled}
            onChange={handleSelectMultipleSelectedChange}
            disabled
            shadow={true}
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            type="radioSelect"
            title="Radio Select"
            placeholder="Select Options"
            options={options}
            value={radioSelect}
            onChange={setRadioSelect}
          />
        </div>
        <div>
          <FormFieldSet
            type="radioSelect"
            title="Radio Select with Search"
            placeholder="Select Options"
            options={options}
            value={radioSelected}
            onChange={setRadioSelected}
            showSearch
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="radioSelect"
            title="Radio Select Disabaled"
            placeholder="Select Options"
            options={options}
            value={radioSelectDisabled}
            onChange={setRadioSelectDisabled}
            disabled
          />
        </div>
        <div>
          <FormFieldSet
            type="radioSelect"
            title="Radio Selected Disabled"
            placeholder="Select Options"
            options={options}
            value={radioSelectedDisabled}
            onChange={setRadioSelectedDisabled}
            disabled
            shadow={true}
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            type="multiSelect"
            title="Multi Select with Checkboxes"
            placeholder="Select Options"
            options={options}
            showSearch
            showViewButton
            onViewClick={handleViewClick}
            value={checkMultiSelect}
            onChange={setCheckMultiSelect}
            showSelectAll={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="multiSelect"
            title="Multi Select Checkboxes with Search"
            placeholder="Select Options"
            options={options}
            value={checkMultiSelected}
            onChange={setCheckMultiSelected}
            showSelectAll={true}
            showSearch
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="multiSelect"
            title="Multi Select with Checkboxes"
            placeholder="Select Options"
            options={options}
            value={checkMultiSelectDisabled}
            onChange={setCheckMultiSelectDisabled}
            showSelectAll={true}
            disabled
          />
        </div>
        <div>
          <FormFieldSet
            type="multiSelect"
            title="Multi Select with Checkboxes"
            placeholder="Select Options"
            options={options}
            value={checkMultiSelectedDisabled}
            onChange={setCheckMultiSelectedDisabled}
            showSelectAll={true}
            disabled
            shadow={true}
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search"
            placeholder="Select Option"
            options={options}
            value={selectWithSearch}
            onChange={handleSelectWithSearchChange}
            showSearch
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search"
            placeholder="Select Option"
            options={options}
            value={selectedWithSearch}
            onChange={handleSelectedWithSearchChange}
            showSearch
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search"
            placeholder="Select Option"
            options={options}
            value={selectWithSearchDisabled}
            onChange={handleSelectWithSearchChange}
            showSearch
            disabled
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search"
            placeholder="Select Option"
            options={options}
            value={selectedWithSearchDisabled}
            onChange={handleSelectWithSearchChange}
            showSearch
            disabled
            shadow={true}
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search and Add Button"
            placeholder="Select Option"
            options={options}
            value={selectWithSearchAndAddButton}
            onChange={handleSelectWithSearchAndAddButtonChange}
            showSearch
            showButton
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search and Add Button"
            placeholder="Select Option"
            options={options}
            value={selectedWithSearchAndAddButton}
            onChange={handleSelectedWithSearchAndAddButtonChange}
            showSearch
            showButton
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search and Add Button"
            placeholder="Select Option"
            options={options}
            value={selectWithSearchAndAddButtonDisabled}
            onChange={handleSelectWithSearchAndAddButtonChange}
            showSearch
            showButton
            disabled
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            label="Input"
            title="Select With Search and Add Button"
            placeholder="Select Option"
            options={options}
            value={selectedWithSearchAndAddButtonDisabled}
            onChange={handleSelectWithSearchAndAddButtonChange}
            showSearch
            showButton
            disabled
            shadow={true}
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            type="selectDefault"
            title="Company Select with Logo"
            placeholder="Select Company"
            options={sampleCompanies}
            value={selectedCompany}
            onChange={handleCompanyChange}
            defaultValue={defaultCompany}
            onSetDefault={handleSetDefault}
            showLogo={true}
          />
        </div>

        <div>
          <FormFieldSet
            type="selectDefault"
            title="Company with Search & Logo"
            placeholder="Select Company"
            options={sampleCompanies}
            value={selectedCompanyWithSearch}
            onChange={handleCompanyWithSearchChange}
            defaultValue={defaultCompanyWithSearch}
            onSetDefault={handleSetDefaultWithSearch}
            showLogo={true}
            showSearch={true}
            shadow={true}
          />
        </div>

        <div>
          <FormFieldSet
            type="selectDefault"
            title="Company Without Logo"
            placeholder="Select Company"
            options={sampleCompanies}
            value={selectedCompanyNoLogo}
            onChange={handleCompanyNoLogoChange}
            defaultValue={defaultCompanyNoLogo}
            onSetDefault={handleSetDefaultNoLogo}
            showLogo={false}
            showSearch={true}
          />
        </div>

        <div>
          <FormFieldSet
            type="selectDefault"
            title="Company Disabled"
            placeholder="Select Company"
            options={sampleCompanies}
            value={selectedCompanyDisabled}
            onChange={setSelectedCompanyDisabled}
            defaultValue={defaultCompanyDisabled}
            onSetDefault={setDefaultCompanyDisabled}
            showLogo={true}
            disabled={true}
            shadow={true}
          />
        </div>
      </div>

      <PropsTable
        data={SELECT_PROPS}
        title="Select — Props Reference"
        typeLabel='type="select"'
        categories={CATEGORIES}
      />
      <PropsTable
        data={RADIO_SELECT_PROPS}
        title="Radio Select — Props Reference"
        typeLabel='type="radioSelect"'
        categories={CATEGORIES}
      />
      <PropsTable
        data={MULTI_SELECT_PROPS}
        title="Multi Select — Props Reference"
        typeLabel='type="multiSelect"'
        categories={CATEGORIES}
      />
      <PropsTable
        data={SELECT_DEFAULT_PROPS}
        title="Select with Default — Props Reference"
        typeLabel='type="selectDefault"'
        categories={CATEGORIES}
      />
    </>
  );
};

export default SelectList;
